import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-service-table-popup',
  template: `
    <app-service-table [dashboardType]="dashboardType" [dashboardGroup]="dashboardGroup" [inPopup]="true" (onClickEdit)="onClickEdit()" (onBack)="dialogRef.close()"></app-service-table>`
})
export class ServiceTablePopupComponent implements OnInit {
  public dashboardType;
  public dashboardGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { dashboardType: string; dashboardGroup: string; },

    public dialogRef: MatDialogRef<ServiceTablePopupComponent>,
  ) {
    if (this.data.dashboardType) {
      this.dashboardType = data.dashboardType;
    }
    if (this.data.dashboardGroup) {
      this.dashboardGroup = data.dashboardGroup;
    }
  }

  ngOnInit() {
  }

  onClickEdit() {
    this.dialogRef.close();
  }
}
